import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=0b8b12ee&scoped=true"
import script from "./DialogBox.vue?vue&type=script&lang=ts"
export * from "./DialogBox.vue?vue&type=script&lang=ts"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=0b8b12ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b12ee",
  null
  
)

export default component.exports